import { gql } from "@apollo/client";

export const GET_CONEXIONES_A_EXPORTAR = gql`
query excelConexionesPendientes {
    excelConexionesPendientes{ 
        error
        success
        valorEsperado{
            region
            delegacion
            idEvaluacion
            tipoModulo
            modulo
            precioDiario
            hC
            paciente
            codCliente
            cliente
        }
    }
}`;